import { expertiseMeetingApi } from '../api/expertise-meeting'

export const {
  useCreateExpertiseMeetingMutation,
  useGetExpertiseMeetingQuery,
  useGetExpertiseMeetingsQuery,
  useGetExpertiseMeetingSessionQuery,
  useGetExpertiseMeetingRequestAccessQuery,
  useReplyExpertiseMeetingRequestAccessMutation,
  useSendExpertiseMeetingRequestAccessMutation,
} = expertiseMeetingApi
